import React from 'react';
import ReactDOM from 'react-dom';
import LogRocket from 'logrocket';
import * as serviceWorker from './serviceWorker';
import initWorkboxRefresh from '@loopmode/cra-workbox-refresh';
import { configureStore as createStore } from './store/configureStore'

// Store Initialization
// ------------------------------------
export const store = createStore(window.__INITIAL_STATE__)

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root')

let render = () => { 
  const Routes = require('./routes').default 

  ReactDOM.render( 
    <Routes store={store} />,
    MOUNT_NODE
  )
}
if(process.env.NODE_ENV === 'production' && !window.location.pathname.includes('print')){
  LogRocket.init('ytvwu0/easyscale');
  window.Raven.config('https://6bbebfab0d4949469f53d889f56dd5a6@sentry.io/1247084').install()
  window.Raven.setDataCallback(function (data) {
    data.extra.sessionURL = LogRocket.sessionURL;
    return data;
  });
}
serviceWorker.register({
  onUpdate: registration => initWorkboxRefresh(registration, {
      textContent: 'Une mise a jour est disponible. Cliquez pour recharger la page.',
      className: 'refresh-button'
  })
});
// Development Tools
// ------------------------------------
if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        console.error(e)
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept([
      './routes',
    ], () =>
      setImmediate(() => {
        console.log("🔥 Reload")
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
}
render()
